<template>
  <section class="section-scan">
    <qrcode-stream @decode="onDecode"></qrcode-stream>
    <!-- <div class>
      <button class="btn btn-lg btn-primary w-100 btn-sticky-bottom" @click="doCoupon()">Proceed</button>
    </div>-->
  </section>
</template>
<script>
import { BASEURL } from "@/config/index";
let BaseURL = BASEURL;

import axios from "axios";
export default {
  name: "qrcode",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  components: {},
  beforeMount() {
    if (!this.$cookies.get("token")) {
      this.$router.replace({
        path: "login"
      });
    }
  },
  methods: {
    onDecode(decodedString) {
      // ...
      console.log("decodedString", decodedString);
      // alert(decodedString);
      this.$router.push({
        name: "CouponStatus",
        params: { couponcode: decodedString }
      });
    },
    doCoupon: function() {
      this.$router.push({
        name: "CouponStatus",
        params: {
          couponcode:
            // "U2FsdGVkX1/XC2znvyZdpg7TbD7nL3CnIpXzYr5ynQTdAj0uPbZ6GJVFIPNhDDqetsGDJdWWvCeavOjtNu8yDw4xeCHmrQYkq8yQARlFKnc="
            "eb42cdd810ca0e80bde7815bdba393625195932ad2838f410d3b7d14a9468e38b129f7640e2ad4ef73a21802eebe3fea2bc2e062d63232b18b5c01fe490b4d9d"
        }
      });
    }
  }
};
</script>
<style>
.section-scan {
  height: calc(100vh - 47px);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/scan.vue